import clsx from 'clsx';
import React from 'react';

import { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';

import ActionButton from '../../../../../../../Elements/ActionButton/ActionButton';
import { useEmailThreadEntryViewer } from '../../../../store/emailThreadEntryViewer.store';

const ToggleSidePanel = () => {
  const { showSidePanel, toggleShowSidePanel } = useEmailThreadEntryViewer();

  return (
    <ActionButton
      id={'info_button'}
      className={clsx('tw-group', 'tw-text-cfo-black')}
      onClick={toggleShowSidePanel}
      tooltipSettings={{
        content: 'View Details',
        place: 'left',
      }}
      icon={ICONS.info}
      iconType={!showSidePanel ? ICON_TYPES.outlined : ICON_TYPES.filled}
    />
  );
};

export default ToggleSidePanel;
